import { Text } from '@chakra-ui/react';
import { useCallback } from 'react';
import { Select, SelectOption } from 'ui-components/dist/Select';
import { selectOptions } from '~/components/TalentRosterCreatorFiltersDrawer/SearchByFollowers';
import { useAdvancedFiltersStore } from '~/screens/store';

export enum PLATFORM_OPTIONS {
  selectPlatform = 'Select Platform',
  instagram = 'instagram',
  tiktok = 'tiktok',
  youtube = 'youtube',
  snapchat = 'snapchat',
}

export const PlatformsToggle: React.FC = () => {
  const { activePlatform, setActivePlatform } = useAdvancedFiltersStore();

  const handlePlatformChange = useCallback(
    (value: any) => {
      setActivePlatform(value.value);
    },
    [setActivePlatform],
  );

  return (
    <>
      <Text fontSize="lg" fontWeight="500" color="primary.600" marginBottom={2}>
        Platform
      </Text>
      <Select
        onChange={handlePlatformChange}
        placeholder="Platform"
        value={
          (activePlatform as string) === PLATFORM_OPTIONS.selectPlatform
            ? selectOptions[0].value
            : activePlatform
        }
        defaultValue={selectOptions[0].value}
      >
        {selectOptions.map((option) => (
          <SelectOption
            key={option.value}
            value={option.value}
            icon={option.icon && <option.icon boxSize={4} />}
          >
            {option.label}
          </SelectOption>
        ))}
      </Select>
    </>
  );
};
